import useAdminSettings from "../../zustand/useAdminSettingsStore";
import { Box, Container, Typography } from "@mui/material";
import AppLoader from "../../components/appLoader";
import he from "he";
import logo from "../../assets/icons/applogo.png";

const PrivacyPolicy = () => {
    const {
        adminSettings,
        isLoading,
    } = useAdminSettings();


    return (
        <>
            <Box
                height={"100vh"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={"column"}
            >
                <AppLoader isVisible={isLoading} />
                <img
                    src={logo}
                    alt="logo"
                    style={{ width: "120px", height: "100px", marginBottom: "20px" }}
                />
                <Container

                    maxWidth="lg"
                    my={4}
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                    height={"100vh"}
                    flexDirection={"column"}
                >
                    <Box
                        bgcolor="primary.bgLight"
                        padding={"20px"}
                        borderRadius={"22px"}
                        mt={0}
                        my={"auto"}
                        px={4}
                        py={2}
                    >
                        <div
                            dangerouslySetInnerHTML={{
                                __html: he.decode(adminSettings?.privacyPolicy || ""),
                            }}
                        />
                    </Box>
                </Container >
            </Box >
        </>
    )
}

export default PrivacyPolicy